import api from '@pray/shared/utils/api';

export type EmailHealthDomain = {
  id: number;
  domain_name: string;
  artist_name: string | null;
  status: 'verified' | 'pending' | 'failed';
  spf: boolean;
  dkim: boolean;
  dmarc: boolean;
  branding: boolean;
  last_validated: string | null;
  postmaster_compliance: {
    spf: string;
    dkim: string;
    dmarc: string;
  } | null;
};

export type EmailHealthDomainsResponse = {
  domains: EmailHealthDomain[];
};

export async function getEmailHealthDomains(): Promise<EmailHealthDomainsResponse> {
  const url = '/web/studio/system-check/email-health/domains';
  const response = await api.executeGetRequest<{ data: EmailHealthDomainsResponse }>(url);

  return response.data.data;
}
